var _omexXmlNamespaces =
  'xmlns="urn:schemas-microsoft-com:office:office" xmlns:o="urn:schemas-microsoft-com:office:office"';
function _getAppSubType(officeExtentionTarget) {
  var appSubType;
  if (officeExtentionTarget === 0) {
    //in content MOE
    appSubType = OSF.AppSubType.Content;
  } else if (officeExtentionTarget === 1) {
    //Taskpane MOE
    appSubType = OSF.AppSubType.Taskpane;
  } else {
    throw OsfMsAjaxFactory.msAjaxError.argument("officeExtentionTarget");
  }
  return appSubType;
}
function _getAppVersion(applicationName) {
  var appVersion = OSF.AppVersion[applicationName.toLowerCase()];
  if (typeof appVersion == "undefined") {
    throw OsfMsAjaxFactory.msAjaxError.argument("applicationName");
  }
  return appVersion;
}
function _invokeCallbackTag(callback, status, result, errorMessage, executor, tagId) {
  var constructedMessage = errorMessage;
  if (callback) {
    try {
      var response = { status: status, result: result, failureInfo: null };
      var setFailureInfoProperty = function _invokeCallbackTag$setFailureInfoProperty(response, name, value) {
        if (response.failureInfo === null) {
          response.failureInfo = {};
        }
        response.failureInfo[name] = value;
      };
      if (executor) {
        var httpStatusCode = -1;
        if (executor.get_statusCode) {
          httpStatusCode = executor.get_statusCode();
        }
        // Do not override message if it already exists
        if (!constructedMessage) {
          if (executor.get_timedOut && executor.get_timedOut()) {
            constructedMessage = "Request timed out.";
          } else if (executor.get_aborted && executor.get_aborted()) {
            constructedMessage = "Request aborted.";
          }
        }
        // Only record detailed info if there is an error or message already being recorded
        if (httpStatusCode >= 400 || status === statusCode.Failed || constructedMessage) {
          setFailureInfoProperty(response, "statusCode", httpStatusCode);
          setFailureInfoProperty(response, "tagId", tagId);
          var webRequest = executor.get_webRequest();
          if (webRequest) {
            if (webRequest.getResolvedUrl) {
              setFailureInfoProperty(response, "url", webRequest.getResolvedUrl());
            }
            // Only record the correlation id if we did not set it in the request
            if (
              executor.getResponseHeader &&
              webRequest.get_userContext &&
              webRequest.get_userContext() &&
              !webRequest.get_userContext().correlationId
            ) {
              // Get the correlation id from OMEX request for better diagnosis
              var correlationId = executor.getResponseHeader("X-CorrelationId");
              setFailureInfoProperty(response, "correlationId", correlationId);
            }
          }
        }
      }
      // Add on built error string information if it exists
      if (constructedMessage) {
        setFailureInfoProperty(response, "message", constructedMessage);
        OsfMsAjaxFactory.msAjaxDebug.trace(constructedMessage);
      }
    } catch (ex) {
      OsfMsAjaxFactory.msAjaxDebug.trace("Encountered exception with logging: " + ex);
    }
    callback(response);
  }
}
namespace OSF {
  export enum AppSubType {
    Taskpane = 1,
    Content = 2,
    Contextual = 3,
    Dictionary = 4,
  }
  export enum AppVersion {
    access = "ZAC150",
    excel = "ZXL150",
    excelwebapp = "WAE160",
    outlook = "ZOL150",
    outlookwebapp = "MOW150",
    powerpoint = "ZPP151",
    powerpointwebapp = "WAP160",
    project = "ZPJ150",
    word = "ZWD150",
    wordwebapp = "WAW160",
    onenotewebapp = "WAO160",
    visio = "ZVO161",
    visiowebapp = "WAV161",
  }
}
